// If it matches the email regex, then make the ajax call
const KEY = "BD97-XT15-AN32-RD33";
const timeout = 5000;

export const validateEmailViaAjax = function (email, input) {
  const $input = $(input);
  const $errorContainer = $input.parents(".field").find(".field__error"); // The FE error container
  const $errorContainers = $(".field__error"); // All error containers - BE and FE
  const $successContainer = $input.parents(".field").find(".field__help");
  const $fieldBox = $input.parents(".field__box");
  const noResultsText = $input.data("no-results");
  const invalidEmailText = $input.data("invalid-email");
  const successText = $input.data("validation-success");
  const timeoutText = $input.data("timeout");

  // Set the spinner
  $fieldBox.addClass("ajaxActive");

  // Make the AJAX call
  const result = $.post(
    "https://api.addressy.com/EmailValidation/Interactive/Validate/v2.00/json3.ws",
    {
      Key: KEY,
      Email: email,
      Timeout: timeout,
    }
  );

  // Process the Promise returned
  result.then(function (result) {
    // Turn off the spinner
    $fieldBox.removeClass("ajaxActive");
    // Clear previous messages, success or error
    $errorContainer.empty().show();
    $errorContainers.empty().show();
    $successContainer.empty().show();
    // Test for an error
    if (
      result.Items.length === 1 &&
      typeof result.Items[0].Error != "undefined"
    ) {
      // Show the error message
      $errorContainer.empty().html(result.Items[0].ReponseMessage).show();
      $input.addClass("error");
      return;
    }

    // Check if there were any items found
    if (result.Items.length === 0) {
      $errorContainer.empty().html(noResultsText).show(); //"Sorry, there were no results"
      $input.addClass("error");
      return;
    }

    // If items found
    if (result.Items.length > 0) {
      // If timeout
      if (result.Items[0].ResponseCode === "Timeout") {
        $errorContainer.empty().html(timeoutText).show(); // "Sorry, timed out, etc"
        return;
      }
      // If valid
      if (
        result.Items[0].ResponseCode === "Valid" ||
        result.Items[0].ResponseCode === "Valid_CatchAll"
      ) {
        $successContainer.empty().html(successText).show(); //Email address was fully validated
        // Remove the error class
        $input.removeClass("error");
        return;
      }
      // Not valid
      $errorContainer.empty().html(invalidEmailText).show(); // "Sorry, please try again, that doesn't look like a valid email"
      $input.addClass("error");
    }
  });
};
